"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _KYC_IMFormStepContainer = _interopRequireDefault(require("./KYC_IMFormStepContainer"));
var _KYCConfirmLevelModal = _interopRequireDefault(require("../../KYC/KYCConfirmLevelModal"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _pick = _interopRequireDefault(require("lodash/pick"));
var _omit = _interopRequireDefault(require("lodash/omit"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var KYC_IMFormComponent = /*#__PURE__*/function (_React$Component) {
  function KYC_IMFormComponent(props) {
    var _this;
    _classCallCheck(this, KYC_IMFormComponent);
    _this = _callSuper(this, KYC_IMFormComponent, [props]);
    _defineProperty(_this, "onSubmit", function () {
      var level = _this.props.level;
      var page = _this.state.page;
      if (level.steps && level.steps[page + 1]) {
        _this.setState({
          page: _this.state.page + 1
        });
      } else {
        _this.openModal(true);
      }
    });
    _defineProperty(_this, "previousPage", function () {
      _this.setState({
        page: _this.state.page - 1
      });
    });
    _defineProperty(_this, "openModal", function (openModal) {
      return _this.setState({
        openModal: openModal
      });
    });
    _defineProperty(_this, "getConfigPayload", function (values) {
      var _this$props = _this.props,
        UserName = _this$props.UserName,
        UserId = _this$props.UserId;
      var configPropsMap = {
        DocumentType: 'docType',
        DocumentState: 'docState',
        DocumentCountry: 'docCountry',
        phone: 'telephone',
        state: 'billingState'
      };
      var Config = Object.keys(values).map(function (prop) {
        return {
          Key: configPropsMap[prop] || prop,
          Value: values[prop]
        };
      });
      // temporarily setting levelIncreaseStatus to under review, no matter what (taken from widgets)
      Config.push({
        Key: 'levelIncreaseStatus',
        Value: 'underReview'
      });
      return {
        UserName: UserName,
        UserId: UserId,
        Config: Config
      };
    });
    _defineProperty(_this, "getUserInfo", function (values) {
      var _this$props2 = _this.props,
        accountId = _this$props2.accountId,
        UserId = _this$props2.UserId,
        useAccountId = _this$props2.useAccountId,
        email = _this$props2.email;
      values = _this.condenseMemos(values);
      return _objectSpread(_objectSpread({}, values), {}, {
        accountName: (useAccountId ? accountId : UserId).toString(),
        email: email,
        billingFlatNumber: '',
        salutation: ''
      });
    });
    _defineProperty(_this, "condenseMemos", function (values) {
      var memos = {};
      var memosAmount = 0;
      Object.keys(values).map(function (key) {
        memosAmount += key.match(/memo/) && (memos[key] = values[key], delete values[key]);
        return values;
      });
      memosAmount > 0 && (values['memo'] = memos);
      return values;
    });
    _defineProperty(_this, "getAdditionalValidation", function (imageFields) {
      return Object.keys(imageFields).filter(function (prop) {
        return imageFields[prop];
      }).map(function (ImageName) {
        return {
          ImageInString: imageFields[ImageName].imgSrc,
          ImageName: ImageName
        };
      });
    });
    _defineProperty(_this, "submitData", function () {
      var _this$props3 = _this.props,
        formValues = _this$props3.formValues,
        uploadFields = _this$props3.uploadFields,
        UserId = _this$props3.UserId,
        MinimumVerificationLevel = _this$props3.MinimumVerificationLevel,
        reset = _this$props3.reset,
        validateUserRegistrationIdentityMind = _this$props3.validateUserRegistrationIdentityMind,
        onSubmit = _this$props3.onSubmit;
      var values = (0, _omit["default"])(formValues, uploadFields);
      var uploadValues = (0, _pick["default"])(formValues, uploadFields);
      var AdditionalValidation = _this.getAdditionalValidation(uploadValues);
      var userInfo = _this.getUserInfo(Object.assign({}, values));
      var setUserConfigPayload = _this.getConfigPayload(values);
      var clientInfo = {
        alphaPointUserID: UserId.toString(),
        validationStage: MinimumVerificationLevel,
        // validation stage, necessary for identityMind
        validator: 'IM'
      };

      // Set params for ValidateUserRegistration request
      var validateUserRegistrationPayload = {
        clientInfo: clientInfo,
        userInfo: userInfo,
        AdditionalValidation: AdditionalValidation
      };
      var submitInfoIdentityMindPayload = {
        validateUserRegistrationPayload: validateUserRegistrationPayload,
        setUserConfigPayload: setUserConfigPayload
      };
      validateUserRegistrationIdentityMind(submitInfoIdentityMindPayload);
      reset();
      onSubmit && onSubmit();
    });
    _defineProperty(_this, "getMissingFieldsMessage", function () {
      var t = _this.props.t;
      var baseClasses = (0, _cssClassesHelper.getBEMClasses)('kyc-form');
      var slidePaneClasses = (0, _cssClassesHelper.getBEMClasses)('slide-pane');
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: slidePaneClasses('body')
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: baseClasses('title')
      }, t('Verification form is not properly setup, please contact the exchange in order to solve this.')));
    });
    _defineProperty(_this, "getSectionsForModal", function (level) {
      var sections = [];
      level.steps.forEach(function (step) {
        sections = [].concat(_toConsumableArray(sections), _toConsumableArray(step.sections));
      });
      return {
        sections: sections
      };
    });
    _this.state = {
      page: 0,
      openModal: false,
      images: {}
    };
    return _this;
  }
  _inherits(KYC_IMFormComponent, _React$Component);
  return _createClass(KYC_IMFormComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var missingFields = this.props.missingFields;
      if (missingFields.length > 0) {
        console.error('The following fields are missing from the configuration file: ', missingFields.map(function (f) {
          return "\"".concat(f.name, "\"");
        }).join(', '));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        processing = _this$props4.processing,
        formValues = _this$props4.formValues,
        level = _this$props4.level,
        missingFields = _this$props4.missingFields;
      var _this$state = this.state,
        page = _this$state.page,
        openModal = _this$state.openModal,
        images = _this$state.images;
      if (missingFields.length > 0) {
        return this.getMissingFieldsMessage();
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_KYC_IMFormStepContainer["default"], {
        isFirst: page === 0,
        level: level.steps ? level.steps[page] : level,
        previousPage: this.previousPage,
        onSubmit: this.onSubmit
      }), /*#__PURE__*/_react["default"].createElement(_KYCConfirmLevelModal["default"], {
        isOpen: openModal,
        close: function close() {
          return _this2.openModal(false);
        },
        onConfirm: this.submitData,
        processing: processing,
        level: level.steps ? this.getSectionsForModal(level) : level,
        values: _objectSpread(_objectSpread({}, formValues), images)
      }));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _reactI18next.withTranslation)('kyc')(KYC_IMFormComponent);